import React from "react";


const Container = ({ children }) => (
    <main>
        {children}
    </main>
);

export default Container;